//kpi-trend.ts
import { KpiDirection } from './kpi-row';

export type KpiTrendVm = {
    trendText: string;
    direction: KpiDirection;
};

export function buildCountTrend(current: number, previous: number, opts?: { label?: string }) {
    const delta = current - previous;

    let direction: 'up' | 'down' | 'flat' = 'flat';
    if (delta > 0) direction = 'up';
    else if (delta < 0) direction = 'down';

    const sign = delta > 0 ? '+' : '';

    return {
        delta,
        direction,
        trendText: `${sign}${delta} ${opts?.label ?? ''}`.trim()
    };
}